import { z } from 'zod'

/**
 * A move in UCI long-algebraic notation: from-square, to-square, optional
 * promotion piece. e.g. "e2e4", "e7e8q".
 */
export const uciMove = z
  .string()
  .regex(/^[a-h][1-8][a-h][1-8][qrbn]?$/, 'must be a UCI move like "e2e4" or "e7e8q"')

export type UciMove = z.infer<typeof uciMove>

/**
 * Loose FEN validation: six space-separated fields, the first of which looks
 * like a piece-placement string. We deliberately do not validate legality here
 * — chess.js is the authority on that, and it lives in @shess/engine.
 */
export const fen = z
  .string()
  .regex(
    /^[1-8pnbrqkPNBRQK/]+ [wb] (-|[KQkq]{1,4}) (-|[a-h][36]) \d+ \d+$/,
    'must be a valid FEN string',
  )

export type Fen = z.infer<typeof fen>

export const squareName = z.string().regex(/^[a-h][1-8]$/)
export type SquareName = z.infer<typeof squareName>

export const color = z.enum(['white', 'black'])
export type Color = z.infer<typeof color>
